import templateUrl from 'emun.shopping.admin/dashboard-ytdsales.htm'
class DashboardYTDSalesController {
    constructor(createAutoQuery) { 
        var params = "";
        this.ytdSales = {
            total: 0,
            count: 0
        };
        this.lySales = {
            total: 0,
            count: 0
        };
        if (this.customerId) {
            params = "&customerId=" + this.customerId;
        } else if (this.salesrepId) {
            params = "&salesrepId=" + this.salesrepId;
        }
        this.ytdSalesQuery = createAutoQuery({
            url: 'QueryOrderTotals.json?dateRange=YTD' + params,
            autoLoad: true,
            onLoaded: args => {this.ytdSales.total = args.first.total; this.ytdSales.count = args.first.count;}
        });
        this.lySalesQuery = createAutoQuery({
            url: 'QueryOrderTotals.json?dateRange=LastYear' + params,
            autoLoad: true,
            onLoaded: args => {this.lySales.total = args.first.total; this.lySales.count = args.first.count;}
        });
    }
}

let DashboardYTDSales = {
    bindings: {
        customerId: '<',
        salesrepId: '<'
    },
    controller: DashboardYTDSalesController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.shopping.admin').component('dashboardYtdSales', DashboardYTDSales);

export default DashboardYTDSales